module.exports = __webpack_public_path__ + "img/food-crates.bb438f42.jpg";